import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";

/**
 * 代理服务
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class AgencyService extends ServiceBase
{
    
    /**
     * 代理商品列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getAgencyoodsPage(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.getAgencyoodsPage({
            data: data
        })
               
        return response;
    }

    /**
     * 新增代理商品
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async addAgencyGoods(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.addAgencyGoods({
            data: data
        })
               
        return response;
    }

    /**
     * 代理上下架
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async agencyGoodsOnOffshelf(id: number): Promise<IHttpResponse>
    {
        let response = await this.apis.agencyGoodsOnOffshelf({
           urlPath:{id}
        })
               
        return response;
    }

    
}